import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sidebar } from "./Sidebar";
import { AutoSyncRunner } from "../../modules/crm-ecommerce/AutoSync";
import { PortalAutoRunner } from "../../modules/sewer-portal/portalAutoRunner";
import { HandoverAutoRunner } from "../../modules/mfg-workcenters/handoverAutoRunner";
import { useApplyDoveToShell } from "../../modules/subcontractors/useDoveTheme";
import { AuditSessionRunner } from "../components/AuditSessionRunner";

export function Shell() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { pathname } = useLocation();
  // The navy-and-glass side navigation, for every module (set in Payroll Settings → Theme).
  useApplyDoveToShell();

  // Close the mobile drawer whenever the route changes (e.g. tapping a nav
  // item or Back/Home) so the user lands on the fresh screen, not the menu.
  useEffect(() => {
    setDrawerOpen(false);
  }, [pathname]);

  // Prevent the page behind the drawer from scrolling while it's open on mobile.
  useEffect(() => {
    if (!drawerOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [drawerOpen]);

  return (
    <div className="shell">
      {/* Mobile-only top bar with a hamburger to reveal the nav drawer.
          Hidden on desktop, where the sidebar is always docked. */}
      <header className="shell-topbar">
        <button
          className="shell-menu-btn"
          onClick={() => setDrawerOpen(true)}
          aria-label="Open navigation menu"
          aria-expanded={drawerOpen}
        >
          <Menu size={22} strokeWidth={2.5} />
        </button>
        <div className="shell-topbar-brand">
          <div className="shell-topbar-logo">iS</div>
          <span className="shell-topbar-name">i-SYNERGY</span>
        </div>
      </header>

      <Sidebar mobileOpen={drawerOpen} onNavigate={() => setDrawerOpen(false)} />

      {/* Scrim behind the drawer on mobile; tap to dismiss. */}
      <div
        className={`shell-scrim ${drawerOpen ? "shell-scrim-open" : ""}`}
        onClick={() => setDrawerOpen(false)}
        aria-hidden="true"
      />

      {/* The "who's here now" heads render inside Sidebar, above your own
          name — every route below /login mounts this Shell, so one placement
          there covers the whole app and no screen has to make room for them. */}

      {/* The e-commerce auto-sync. Here, above the routes, so it ticks whichever
          screen is showing — see AutoSync.tsx. Renders nothing. */}
      <AutoSyncRunner />
      <HandoverAutoRunner />
      <PortalAutoRunner />

      {/* Records how long each signed-in person uses the app, for the Audit Log.
          Here for the same reason as the sync above: above the routes, so it
          covers whichever screen is showing. Renders nothing. */}
      <AuditSessionRunner />

      <main className="shell-content">
        <Outlet />
      </main>
    </div>
  );
}
